import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SESSION_STORAGE } from '@ng-web-apis/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { RouteTranslateService } from '../../../common/route-translate/route-translate.service';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  public refreshObservable: Observable<boolean>;
  private refreshSubject: BehaviorSubject<boolean>;

  constructor(
    private router: Router,
    private routeTranslateService: RouteTranslateService,
    @Inject(SESSION_STORAGE) private sessionStorage: Storage,
  ) {
    this.refreshSubject = new BehaviorSubject<boolean>(false);
    this.refreshObservable = this.refreshSubject.asObservable();
  }

  setSearchRefresh(value: boolean) {
    this.refreshSubject.next(value);
  }

  getSearchRefresh() {
    return this.refreshSubject.value;
  }

  categorySearch(id: string, address: string, latitude: number, longitude: number, distance?: number) {
    this.sessionStorage.removeItem('previousSearch');
    this.sessionStorage.removeItem('previousSearch__map');
    this.router.navigate([this.routeTranslateService.translateRoute('search-results')], {
      queryParams: {
        value: address,
        searchCategories: id,
        latitude,
        longitude,
        interaction: 'click',
        distance: distance || 300,
        prefix: 'location',
        mode: 'list',
      },
      state: { refresh: true },
    });
  }

  locationSearch(
    address: string,
    latitude: number,
    longitude: number,
    activeId?: string,
    activeType?: string,
    mode?: string,
  ) {
    this.sessionStorage.removeItem('previousSearch');
    this.sessionStorage.removeItem('previousSearch__map');
    this.router.navigate([this.routeTranslateService.translateRoute('search-results')], {
      queryParams: {
        value: address,
        latitude,
        longitude,
        distance: 10,
        interaction: 'click',
        prefix: 'location',
        mode: mode || 'map',
        activeId,
        activeType,
      },
      state: { refresh: true },
    });
  }
}
